(ns frontend.view.components.form.components.form-ratings
  (:require
   [frontend.view.components.ratings :as ratings]
   [reagent.core :as r]
   [frontend.bootstrap.components :as rbs]
   [clojure.string :as string]
   [frontend.view.modals.ratings.deal :as ratings-deal]
   [frontend.view.modals.events :as modals]
   [frontend.utils :as fu]
   [ui.components.card.view :as card]))

(def scale (range 1 6))
(def scale-count (count scale))
(def step
  (->> scale-count
       (/ 1)))

(defn round-average
  [average]
  (if (number? average)
    (.toFixed average 1)
    "N/A"))

(defn ratings-circle
  [{:keys [label classes is-not-applicable?]}]
  (let [label (if is-not-applicable?
                label
                (-> label
                    str
                    (string/split #"\.|,")))]
    [card/card
     (if is-not-applicable?
       [:p.text-label label]
       [:p.text-label
        (first label) ","
        [:span.text-label__small (last label)]])]))

(defn ratings-block
  [{:keys [label accounts value edit? set-edit! on-change! on-submit!]}]
  (let [not-applicable "n/a"
        shown-value (if (> (count value) 0)
                      (round-average (/ (reduce + (map #(* ratings/scale-count %) (vals value)))
                                        (count value)))
                      not-applicable)
        open-ratings-modal! (fn self
                              ([]
                               (self value))
                              ([value]
                               (modals/open-modal! ratings-deal/modal-key
                                                   {:label      label
                                                    :accounts   accounts
                                                    :value      value
                                                    :step       step
                                                    :scale      scale
                                                    :set-edit!  set-edit!
                                                    :on-change! (fn [v]
                                                                  (on-change! v)
                                                                  (on-submit!)
                                                                  ;; NOTE: This passes new value to the props in modals
                                                                  (self v))
                                                    :on-submit! on-submit!})))
        _ (when @edit?
            (open-ratings-modal!))]
    [:div.form-ratings
     {:on-click (when (fn? set-edit!)
                  #(set-edit! true))}
     [ratings-circle
      {:label   shown-value
       :classes (fu/cs "form-ratings__circle-text"
                       (when-not (= shown-value not-applicable)
                         "hasValue"))
       :is-not-applicable? (= shown-value not-applicable)}]]))

;; TODO This needs to be deleted and replaced with ratings-block
;; Need to know why ratings is available in Web form?
(defn view
  [{:keys [label size value wrapper field control-id accounts edit? set-edit! on-change!
           on-submit!]}]
  (let [attachments (:attachments field)
        edit-tooltip (r/as-element [rbs/Tooltip
                                    {:class "in"
                                     :id    "edit-tooltip"}
                                    [:i.fal.fa-edit] " Click to Edit"])]
    [rbs/Form
     {:on-submit on-submit!}
     [rbs/FormGroup
      [ratings/ratings-view
       {:value     value
        :accounts  accounts
        :edit?     @edit?
        :on-change (fn [value e]
                     (on-change! value)
                     (on-submit! e))}]]]))
